<gc-button
  [variant]="'secondary'"
  [icon]="'check'"
  [iconSize]="'medium'"
  (clicked)="markAsDone.emit()"
  >{{ 'reportInput.markAsDone' | translate }}</gc-button
>
